<template>
  <svg width="18" height="18" viewBox="0 0 18 18" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path id="Tick Square_2" fill-rule="evenodd" clip-rule="evenodd"
          d="M5.7525 1.5H12.255C14.7975 1.5 16.5 3.285 16.5 5.94V12.0683C16.5 14.715 14.7975 16.5 12.255 16.5H5.7525C3.21 16.5 1.5 14.715 1.5 12.0683V5.94C1.5 3.285 3.21 1.5 5.7525 1.5ZM8.57215 11.2425L12.1346 7.67997C12.3896 7.42497 12.3896 7.01247 12.1346 6.74997C11.8796 6.49497 11.4596 6.49497 11.2046 6.74997L8.10715 9.84747L6.79465 8.53497C6.53965 8.27997 6.11965 8.27997 5.86465 8.53497C5.60965 8.78997 5.60965 9.20247 5.86465 9.46497L7.64965 11.2425C7.77715 11.37 7.94215 11.43 8.10715 11.43C8.27965 11.43 8.44465 11.37 8.57215 11.2425Z"/>
  </svg>
</template>

<script>
export default {
  name: "IconTickSquare"
}
</script>

<style scoped>

</style>